



































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";
import { PagedResults, EmptyPagedResults, infiniteLoad, PagingParams } from "@abaco/web-common/src/Paging";
import { Rule } from "../private/InputMixin";
import { ApiCall } from "./ApiCall";
import AbcAutocomplete from "../input/AbcAutocomplete.vue";
import AbcInfiniteSupport from "./AbcInfiniteSupport.vue";

@Component({
    components: {
        AbcAutocomplete,
        AbcInfiniteSupport,
    },
})
export default class AbcInfiniteAutocomplete extends Vue {
    @Prop() label!: string | null;
    @Prop() value!: unknown;
    @Prop() itemName!: string;
    @Prop() dataProvider!: ApiCall;
    @Prop({ type: Boolean }) isDisabled!: boolean;
    @Prop({ type: Boolean }) isRequired!: boolean;
    @Prop() forceReload!: number;
    @Prop({ default: null }) initFilter!: string | null;
    @Prop({ default: "200px" }) maxHeight!: string;
    @Prop() placeholder!: string;
    @Prop() resetFilter!: number;
    @Prop() rules!: Rule[];
    @Prop({ type: Boolean }) leftTools!: boolean;
    @Prop({ type: Boolean }) rightTools!: boolean;
    @Prop({ type: Boolean }) buttons!: boolean;
    @Prop({ default: (v: unknown) => v, type: Function }) readonly stringify!: (v: unknown) => string;

    private filter: string | null = null;
    private page: PagedResults<unknown> = new EmptyPagedResults();
    private resetId = 0;
    private lastResponse = 0;
    private inFlight = false;

    mounted() {
        this.filter = this.initFilter;
    }

    @Watch("resetFilter")
    onResetFilter() {
        this.filter = this.initFilter;
    }

    get curItem(): unknown {
        return this.value;
    }

    set curItem(val: unknown) {
        this.$emit("input", val);
    }

    @Watch("filter")
    @Debounce(500)
    async waitAndReset(){
        this.resetAndLoad();
    }

    // Decoupled from reset to effectvly force reload, do not remove
    @Watch("forceReload")
    async resetAndLoad() {
        if (this.isDisabled) {
            return;
        }
        this.page = new EmptyPagedResults();
        this.resetId += 1;
    }

    private async loadItems(): Promise<boolean> {
        const beforeCallId = this.resetId;
        const newPage = await infiniteLoad((paging: PagingParams) => this.dataProvider(this.filter, paging), this.page);
        // Discard responses if another request has been done in the while
        if (this.resetId > beforeCallId) {
            // Visualize loading only if the newly created request has not responded yet
            if (this.lastResponse < beforeCallId) {
                this.inFlight = true;
            }
            return false;
        }
        this.lastResponse = beforeCallId;
        this.inFlight = false;
        if (newPage) {
            this.page = newPage;
            return true;
        }
        return false;
    }
}
